import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { articles } from '../content/data';

const Research = () => {
  return (
    <section id="articles" className="section-padding bg-gray-50 dark:bg-gray-900/50">
      <div className="container-max">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-dm-sans font-bold text-text-slate dark:text-surface-white mb-4">
            Articles
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Three published pieces on stablecoins and digital asset infrastructure.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article, index) => (
            <motion.div
              key={article.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
              className="card group"
            >
              <div className="space-y-4">
                {/* Publication & Date */}
                <div className="flex items-center justify-between text-sm">
                  <span className="text-accent-crimson font-medium">
                    {article.publication}
                  </span>
                  <span className="text-gray-500 dark:text-gray-400">
                    {new Date(article.date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric'
                    })}
                  </span>
                </div>

                {/* Title */}
                <h3 className="text-lg font-semibold text-text-slate dark:text-surface-white group-hover:text-accent-crimson transition-colors">
                  {article.title}
                </h3>

                {/* Tags */}
                <div className="flex flex-wrap gap-2">
                  {article.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className="px-2 py-1 bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 text-xs font-medium rounded"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                {/* Actions */}
                <div className="flex items-center space-x-4 pt-2">
                  <motion.a
                    whileHover={{ x: 5 }}
                    href={article.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-2 text-accent-crimson font-medium text-sm hover:text-accent-crimson/80 transition-colors"
                  >
                    <span>Read article</span>
                    <ExternalLink size={14} />
                  </motion.a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Research;
